import styles from './ProductProperty.module.scss'
import React from 'react'
import classNames from 'classnames'

type Props = {
  label: string,
  value: string | number | undefined | null,
  bigValue?: boolean
}

const ProductProperty = (props: Props) => {
  const classes = classNames(styles.property, {
    [styles.bigValue]: props.bigValue,
  })

  return (
    <div className={classes}>
      <div className={styles.label}>
        {props.label}
      </div>
      <div className={styles.value}>
        {props.value}
      </div>
    </div>
  )
}

export default ProductProperty